/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = {
  documents: 'documents',
  issued: 'issued',
  recipient: 'recipient',
  viewSave: 'viewSave',
  noDocuments: 'noDocuments',
  documentType: {
    INVOICE: 'documentType.INVOICE',
    CONFIRMATION: 'documentType.CONFIRMATION',
    OPTION_CONFIRMATION: 'documentType.OPTION_CONFIRMATION',
    ITINERARY: 'documentType.ITINERARY',
    PRRL_TRAVEL_PLAN: 'documentType.PRRL_TRAVEL_PLAN',
    PRECONTRACTUAL: 'documentType.PRECONTRACTUAL',
    BOOKING_PROMOTION_VOUCHER: 'documentType.BOOKING_PROMOTION_VOUCHER',
    VOUCHER: 'documentType.VOUCHER',
    INVOICE_COMPENSATION: 'documentType.INVOICE_COMPENSATION',
    EXT_DOCUMENT: 'documentType.EXT_DOCUMENT',
    QUOTATION: 'documentType.QUOTATION',
    BOOKING_NUMBER_LIST: 'documentType.BOOKING_NUMBER_LIST',
    ETIX: 'documentType.ETIX',
    UNKNOWN: 'documentType.UNKNOWN'
  }
}; export default Keys;